import React, { useEffect } from 'react';
import { Dimmer, Loader, Segment } from 'semantic-ui-react';
import { Outlet, useLocation } from 'react-router';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import CampaignTabsHeader from './subcomponents/Header';
import campaignActions from 'actions/campaigns';
import { Error404, Error500 } from 'pages/ErrorPages';
import BulkActionsProvider from 'shared/context/BulkActionsProvider';
import recentsActions from 'actions/recents';
import { FAVORITE_TYPE } from 'shared/constants/FAVORITE_TYPE';
import RestrictedView from 'shared/RestrictedView';
import { USER_PERMISSIONS } from 'dyl-components';
import campaignUsersActions from 'actions/campaign_users';

const CampaignTabs = () => {
    const id = Number(useParams().id);
    const dispatch = useDispatch();
    const recents = useSelector(state => state.recents || {});
    const {pathname} = useLocation();
    

    useEffect(() => {
        dispatch(campaignActions.readCampaign(id));
        dispatch(campaignUsersActions.readCampaignUsers(id));
        if (!recents?.isAddingRecent && pathname?.includes("/dashboard")) {
            dispatch(recentsActions.addRecent({ external_id: id, page_type: FAVORITE_TYPE.CAMPAIGN }))
        }
    // eslint-disable-next-line
    }, [id, dispatch]);

    

    const { isReadingCampaign, campaign, campaignError, userNotInCompanyCampaign } = useSelector(state => ({
        isReadingCampaign: state.campaigns.isReadingCampaign,
        campaign: state.campaigns.campaign,
        campaignError: state.campaigns.campaignError,
        userNotInCompanyCampaign: !state.campaign_users.users.map(user => user.user_id).includes(state.auth.user_id),
    }));

    const isCampaign = campaign?.is_company_campaign || {};
    const isCompanyCampaign = Object.keys(isCampaign)?.length > 1;

    if (isReadingCampaign) {
        return (
            <Dimmer active>
                <Loader active />
            </Dimmer>
        );
    }

    return (
        <RestrictedView type="restricted" userPermission={USER_PERMISSIONS.CAMPAIGNS_VIEW} userRestrict modifiers={isCompanyCampaign ? 'company' : 'personal'}>
            {(!isReadingCampaign && campaignError) ?
                <Error500 message={"Something went wrong"} />
                : (!isReadingCampaign && !campaign?.id) ?
                    <Error404 message={"Campaign not found"} />
                    : <Segment className='CampaignTabs' basic>
            <BulkActionsProvider>
                            <CampaignTabsHeader id={id} campaign={campaign} userNotInCompanyCampaign={userNotInCompanyCampaign}/>
            </BulkActionsProvider>
                        <Outlet />
                    </Segment>
            }
        </RestrictedView>
    );
}

export default function CampaignTabsContainer() {
    return (
        <BulkActionsProvider>
            <CampaignTabs />
        </BulkActionsProvider>
    )
};
